import React, { createContext, useState, useCallback } from 'react';

// ============================================================
type QueryData = {
  id?: string;
  title?: string;
  label?: string;
  element?: any | undefined;
  elementId?: string | null;
  elementDataId?: string | null;
  ecrfId?: string | null;
};

type QueryContextType = {
  isOpen: boolean;
  open: (data?: QueryData) => void;
  close: () => void;
  toggle: () => void;
  data: QueryData | null;
};
// ============================================================

export const QueryPanelContext = createContext<QueryContextType | undefined>(undefined);

export const QueryPanelProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<QueryData | null>(null);

  const open = useCallback((newData?: QueryData) => {
    setData(newData || null);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    setData(null);
  }, []);

  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  return (
    <QueryPanelContext.Provider value={{ isOpen, open, close, toggle, data }}>
      {children}
    </QueryPanelContext.Provider>
  );
}